<svg
  class="star"
  *ngFor="let i of [1, 2, 3, 4, 5]"
  (mouseover)="setRate(i)"
  (mouseout)="setRate(savedValue)"
  (click)="onClickRating(i)"
  [attr.tabindex]="disabled ? null : 0"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 15 14"
>
  <defs>
    <linearGradient [id]="getId(i, false)" x1="0" x2="100%" y1="0" y2="0">
      <stop [attr.offset]="getOffset(i, rating) + '%'" stop-color="#edaf00"></stop>
      <stop offset="0%" stop-color="#d4d6d9"></stop>
    </linearGradient>
  </defs>
  <path
    [attr.fill]="getId(i, true)"
    d="M7.5 0L9.18386 5.18237H14.6329L10.2245 8.38525L11.9084 13.5676L7.5
  10.3647L3.09161 13.5676L4.77547 8.38525L0.367076 5.18237H5.81614L7.5 0Z"
  />
</svg>
